export default __webpack_public_path__ + "static/media/Logo1.2a5ab942.svg";